import {
  ExternalConnection,
  ExternalConnectionsProviders,
  ID,
} from '@griply/types';

export const getConnectionProvider = (
  connections: ExternalConnection[],
  connectionId: ID,
): ExternalConnectionsProviders =>
  connections.find(({ id }) => id === connectionId)?.provider ??
  ExternalConnectionsProviders.Google;
